// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {

});

export function html1_viewportEnter(event) {
	//Add your code for this event here: 
}